import { ChevronRight } from "lucide-react";
import type { VaultMode } from "./api.js";

export const MODE_LABELS: Record<VaultMode, string> = {
  kid: "For my child",
  guardian: "For myself, with one trusted person",
  circle: "For myself, with several trusted people",
};

export const MODE_ICONS: Record<VaultMode, string> = { kid: "👶", guardian: "🤝", circle: "🔐" };

export const MODE_DESCRIPTIONS: Record<VaultMode, string> = {
  kid: "You (the parent) own the vault and are the only one who can open recordings. Your child's device will get a notification whenever you view its recordings. Metadata (map, events) is always yours to see.",
  guardian:
    "You configure Tether for your own phone or glasses. If you go missing or need help, one designated co-owner can open the recordings on your behalf. You both see the map and events any time.",
  circle:
    "You choose 3 to 5 trusted people. A quorum of them must approve to open any recordings. Strongest privacy; hardest to open without collaboration.",
};

export function ModePicker({
  onPick,
  title = "Who is this vault for?",
}: {
  onPick: (mode: VaultMode) => void;
  title?: string;
}) {
  return (
    <div style={{ maxWidth: 720, margin: "0 auto" }}>
      <h2 style={{ marginBottom: 4 }}>{title}</h2>
      <p className="muted" style={{ marginTop: 0 }}>
        Choose a mode. This decides the setup and how recordings can be opened. You cannot change it
        later.
      </p>
      <div style={{ display: "grid", gap: 12, marginTop: 16 }}>
        {(["guardian", "kid", "circle"] as VaultMode[]).map((m) => (
          <button
            key={m}
            onClick={() => onPick(m)}
            style={{
              display: "block",
              width: "100%",
              padding: 18,
              border: `1px solid var(--line)`,
              borderRadius: 12,
              cursor: "pointer",
              background: "var(--panel)",
              textAlign: "left",
            }}
            className="mode-card"
          >
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <div className="mode-emoji">{MODE_ICONS[m]}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 17, fontWeight: 700, color: "var(--text)" }}>
                  {MODE_LABELS[m]}
                  {m === "guardian" && (
                    <span className="badge" style={{ marginLeft: 10 }}>
                      recommended
                    </span>
                  )}
                </div>
                <div className="muted" style={{ marginTop: 6 }}>
                  {MODE_DESCRIPTIONS[m]}
                </div>
              </div>
              <ChevronRight size={20} color="var(--accent)" style={{ flexShrink: 0 }} />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
